import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@mui/material";
import { blue } from "@mui/material/colors";
import { CheckBox, CheckBoxOutlineBlank, Visibility } from "@mui/icons-material";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import PostsaleIcon from "../../components/OrderHistoryPostsaleIcon/OrderHistoryPostsaleIcon";
import RegularButton from "../../components/CustomButtons/Button";
import OrdersHistoryModals from "../../components/OrdersHistoryModal/OrdersHistoryModals";
import { statusStyle } from "../../helpers/statusVariable";
import { formatNumber } from "../../helpers/getNumberFormats";
import { useColorTheme } from "../../hooks/useColorTheme";
import {
  getDetail,
  getPostsale,
  clearDetail,
  removeOrdersSelected,
  addOrdersSelected,
} from "../../redux/ducks/ordersHistory";
import { ColumnContainer, StatusContainer } from "./styles";

const configTable = [
  {
    Header: "Cliente",
    accessor: "customer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.customer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Cuenta",
    accessor: "account",
    filterable: true,
    filterMethod: (filter, row) =>
      row.account.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Nombre Cliente",
    accessor: "customerName",
    filterable: true,
    filterMethod: (filter, row) =>
      row.customerName.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Teléfono",
    accessor: "phone",
    filterable: true,
    filterMethod: (filter, row) =>
      row.phone.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) =>
      row.type.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Folio ticket",
    accessor: "folio",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.folio)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Cantidad Surtida",
    accessor: "quantity",
    filterable: true,
    filterMethod: (filter, row) =>
      row.quantity
        ? row.quantity.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Metodo de pago",
    accessor: "paymentType",
    filterable: true,
    filterMethod: (filter, row) =>
      row.paymentType.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Monto",
    accessor: "total",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.total)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
    Cell: ({ original }) => formatNumber(original.total, "$", true),
  },
  {
    Header: "Descuento",
    accessor: "discount",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.discount)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Fecha programada",
    accessor: "programDate",
    filterable: true,
    filterMethod: (filter, row) =>
      row.programDate.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estatus",
    accessor: "status",
    className: "no_padding",
    Cell: (props) => (
      <StatusContainer
        className={props.value ? statusStyle[props.value.toUpperCase()] : ""}
      >
        {props.value}
      </StatusContainer>
    ),
    filterable: true,
    filterMethod: (filter, row) =>
      row.status.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Unidad",
    accessor: "unit",
    filterable: true,
    filterMethod: (filter, row) =>
      row.unit.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Usuario",
    accessor: "user",
    filterable: true,
  },
  {
    Header: "Postventa",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: (props) => {
      const dispatch = useDispatch();
      return (
          <ColumnContainer justify="center">
            {props.original.posSale && props.original.posSale.url ? (
                <a
                    href={props.original.posSale.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  <PostsaleIcon order={props.original} />
                </a>
            ) : (
                <RegularButton
                    color="transparent"
                    justIcon
                    round
                    onClick={() => dispatch(getPostsale(props.original.id))}
                >
                  <PictureAsPdfIcon style={{ color: blue[800] }} />
                </RegularButton>
            )}
          </ColumnContainer>
      );
    },
  },
  {
    Header: "Detalles",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const isLoadingDetail = useSelector(
        (state) => state.ordersHistory.isLoadingDetailInfo
      );
      const colorBg = useSelector((state) => state.config.colorBg);
      const detail = useSelector((state) => state.ordersHistory.detail);

      const [itemIdModal, setItemIdModal] = useState(false);
      const [typeModal, setTypeModal] = useState(false);
      const [modal, setModal] = useState(false);
      const { colorRGB } = useColorTheme(colorBg);

      const handleOpenModalDetail = (item) => {
        dispatch(getDetail(item.id));
        setItemIdModal(item.id);
        setTypeModal(item.type);
        setModal(true);
      };

      const handleCloseModalDetail = () => {
        setItemIdModal(null);
        dispatch(clearDetail());
        setModal(false);
      };

      const fetchPostsale = useCallback(() => {
        dispatch(getPostsale(original.id));
      }, [original.id]);

      return (
        <>
          <ColumnContainer justify="center">
            <RegularButton
              tooltip="Detalles"
              round
              justIcon
              color="transparent"
              onClick={() => handleOpenModalDetail(original)}
            >
              <Visibility style={{ color: blue[900] }} />
            </RegularButton>
          </ColumnContainer>
          <OrdersHistoryModals
            modal={modal}
            id={itemIdModal}
            itemModal={detail}
            type={typeModal}
            isLoading={isLoadingDetail}
            colorRGB={colorRGB}
            onCloseModalDetail={handleCloseModalDetail}
            onPostsale={fetchPostsale}
          />
        </>
      );
    },
  },
  {
    accessor: "isSelected",
    Header: "",
    sortable: false,
    filterable: false,
    Cell: (props) => {
      const dispatch = useDispatch();
      const addOrders = useCallback(
        (orders) => {
          dispatch(addOrdersSelected(orders));
        },
        []
      );
      const removeOrders = useCallback(
        (orders) => {
          dispatch(removeOrdersSelected(orders));
        },
        []
      );
      return (
        <ColumnContainer justify="center">
          <Checkbox
            checkedIcon={<CheckBox style={{ color: blue[900] }} />}
            checked={props.value}
            onChange={() =>
              !props.value
                ? addOrders([props.original])
                : removeOrders([props.original])
            }
            icon={<CheckBoxOutlineBlank />}
          />
        </ColumnContainer>
      );
    },
  },
];

const menuOptions = {
  select: "Selecionar todos",
  deselect: "Deseleccionar todos",
};

export { configTable, menuOptions };
